var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M122.72,15.22H4.28c-1.18,0-2.32.5-3.12,1.37l-.03.03C.42,17.4.02,18.41.02,19.47v80.47c0,6.53,5.31,11.84,11.84,11.84h103.27c6.53,0,11.84-5.31,11.84-11.84V19.47c0-2.35-1.91-4.26-4.26-4.26ZM63.5,67.57L15.29,23.73h96.42l-48.21,43.84ZM115.14,103.28H11.86c-1.83,0-3.32-1.5-3.32-3.34V29.1l52.1,47.38c.78.71,1.79,1.1,2.86,1.1s2.09-.39,2.86-1.1l52.11-47.39v70.86c0,1.84-1.5,3.34-3.34,3.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.14dbf5b26f361c210b6921a42bfff6fc.svg";
export { ForwardRef as ReactComponent };